import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Visa Fordonsstatus ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_route_tab = _resolveComponent("q-route-tab")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!

  return (_openBlock(), _createBlock(_component_q_toolbar, { class: "q-px-none" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_tabs, {
        "inline-label": "",
        modelValue: _ctx.activeNavigationTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeNavigationTab) = $event)),
        "outside-arrows": "",
        "mobile-arrows": "",
        style: {"max-width":"100%"},
        class: "text-black",
        "active-color": "primary"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigationTabs, (navigationTab) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: navigationTab.key
            }, [
              (!navigationTab.children)
                ? (_openBlock(), _createBlock(_component_q_route_tab, {
                    key: 0,
                    to: navigationTab.to,
                    name: navigationTab.key,
                    label: navigationTab.label
                  }, {
                    default: _withCtx(() => [
                      (navigationTab.badge)
                        ? (_openBlock(), _createBlock(_component_q_badge, {
                            key: 0,
                            color: navigationTab.badgeColor,
                            rounded: "",
                            floating: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(navigationTab.badge), 1)
                            ]),
                            _: 2
                          }, 1032, ["color"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to", "name", "label"]))
                : (_openBlock(), _createBlock(_component_q_btn_dropdown, {
                    key: 1,
                    "auto-close": "",
                    stretch: "",
                    flat: "",
                    label: navigationTab.label
                  }, _createSlots({
                    default: _withCtx(() => [
                      _createVNode(_component_q_list, { padding: "" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigationTab.children, (child) => {
                            return (_openBlock(), _createBlock(_component_q_item, {
                              clickable: "",
                              onClick: 
                () => {
                  if (child.modal) {
                    child.modal()
                  } else {
                    _ctx.routerPush(child.key)
                  }
                }
              ,
                              key: child.key
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(child.label), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_q_item_section, { avatar: "" }, {
                                  default: _withCtx(() => [
                                    (child.badge)
                                      ? (_openBlock(), _createBlock(_component_q_badge, {
                                          key: 0,
                                          color: child.badgeColor,
                                          rounded: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(child.badge), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["color"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, [
                    (navigationTab.badge)
                      ? {
                          name: "label",
                          fn: _withCtx(() => [
                            _createVNode(_component_q_badge, {
                              class: "tab-badge",
                              color: navigationTab.badgeColor,
                              rounded: "",
                              floating: "",
                              style: {"margin-right":"7px","margin-top":"7px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(navigationTab.badge), 1)
                              ]),
                              _: 2
                            }, 1032, ["color"])
                          ])
                        }
                      : undefined
                  ]), 1032, ["label"]))
            ], 64))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_space),
      (_ctx.$route.name === 'vehicle-withdrawal')
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            class: "text-dark",
            icon: "",
            flat: "",
            size: "sm",
            stretch: "",
            onClick: _cache[1] || (_cache[1] = () => (_ctx.showVehicleStatusMenu = !_ctx.showVehicleStatusMenu))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "mdi-backburger",
                class: "q-pr-md"
              }),
              _hoisted_1
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}